if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // this.input.addEventListener('keydown', function(event) {
      //   if (event.key === 'Enter') {
      //     event.preventDefault();
      //     event.target.blur();
      //   }
      // })
      this.input.addEventListener('input', () => {
        this.change_quantity(0)
      })
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

      this.validateQtyRules();
    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }

      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);
      // Output number
      this.input.value = quantity;
      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.quantity = this.querySelector('.qty');
      this.cartPopupDelay = null
      this.addToCartBtn = this.querySelector('.product-card--add-to-cart-button');
      this.selectedVariant = this.querySelector('.product-card-variants-modal__button');
      this.modalDialog = this.querySelector('.product-card-variants-modal');
      this.productTitle = this.querySelector('.product-card-title');
    }

    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }

      if (this.getAttribute('data-variant-pack-quantity-badges-enabled') === 'true'){
        this.enablePackQuantityBadges();
      }
      
      if (this.productTitle) {
        this.productTitle.addEventListener('focus', this.scrollIntoViewOnFocus.bind(this));
      }
    }
    
    scrollIntoViewOnFocus(event) {
      const element = event.target;
      if (element && typeof element.scrollIntoView === 'function') {
        setTimeout(() => {
          element.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'nearest',
            inline: 'nearest'
          });
        }, 50);
      }      
    }

    enablePackQuantityBadges() {
      const badges = this.querySelectorAll('.product-card-variant-badge');
      const productPackQuantityBadges = Array.from(badges).map((badge) => {
        return {
          variantId: badge.getAttribute('data-variant-id'),
          packQuantity: badge.getAttribute('data-pack-quantity'),
          element: badge
        }
      });

      const modal = this.querySelector('.product-card-variants-modal');
      if (modal && productPackQuantityBadges.length > 0) {
        modal.addEventListener('change', (event) => {
          if (event.target && event.target.name === 'product-variant-select') {

            // Hide all badges initially
            productPackQuantityBadges.forEach((badge) => {
              badge.element.classList.remove("active");
            });
            
            const selectedVariantId = event.target.id;
            const badgeInfo = productPackQuantityBadges.find(badge => badge.variantId === selectedVariantId);

            // Change selected variant data attribute
            this.setAttribute('data-selected-variant-id', selectedVariantId);
            
            const shouldShowBadge = badgeInfo && badgeInfo.packQuantity && badgeInfo.packQuantity !== '0' && badgeInfo.packQuantity !== '' && badgeInfo.packQuantity !== 'nil';

            if (shouldShowBadge) {
              badgeInfo.element.classList.add("active");
            }
          }
        });
      }

        // set up initial badge display based on selected variant
        const selectedVariantId = this.getAttribute('data-selected-variant-id');
          
        if (badges && badges.length > 0) { 
          const variantMatch = productPackQuantityBadges.find(badge => badge.variantId === selectedVariantId);
          variantMatch.element.classList.add("active");
        }
    }

    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', function () {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);
      this.quick_add.setAttribute('aria-busy', 'true');

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);
      
      
      const modalDialog = this.querySelector('.product-card-variants-modal');
      let productId;
      if(modalDialog){
        productId = this.quick_add.dataset.selectedProductId || this.addToCartBtn?.getAttribute('data-product-id');
        formData.append('id', productId);
      } else {
        productId = this.quick_add.dataset.productId;
        formData.append('id', productId);
      }

      const quantityElement = this.quantity ? this.quantity.value : null;
      if (quantityElement !== null) {
        formData.append('quantity', this.quantity.value);
      }
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);
          
          const productTitle = response.hasOwnProperty('items') ? response.items[0].title : response.title;
          this.announceCartUpdate(productTitle);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
          this.quick_add.removeAttribute('aria-busy');
        });

      return false;
    }
    
    announceCartUpdate(productTitle) {
      let liveRegion = document.getElementById('cart-live-region-text');
      if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.id = 'cart-live-region-text';
        liveRegion.setAttribute('role', 'status');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.className = 'visually-hidden';
        document.body.appendChild(liveRegion);
      }
      
      const message = theme.strings?.addedToCart 
        ? theme.strings.addedToCart.replace('{{ product }}', productTitle)
        : `${productTitle} wurde zum Warenkorb hinzugefügt`;
      
      liveRegion.textContent = '';
      setTimeout(() => {
        liveRegion.textContent = message;
      }, 100);
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Notification',
        section: 'cart-drawer',
        selector: '.cart-popup'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      const cartDrawer = document.getElementById('Cart-Drawer');
      const cartDrawerActive = cartDrawer?.classList?.contains('active');
      const lineItems = cartDrawer?.querySelectorAll(".cart-item__grid quantity-selector");
      const firstAtc = lineItems?.length === 1 && lineItems[0].querySelector('input[value="1"]');

      const cartNotification = document.getElementById('Cart-Notification');
      if (cartNotification && !cartDrawerActive && !firstAtc) {
        if (window.cartNotificationTimeout) {
          clearTimeout(window.cartNotificationTimeout);
        }
        cartNotification.classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
        // Remove active state after 6s
        window.cartNotificationTimeout = setTimeout(()=> {
          cartNotification.classList.remove('active');
        }, 6000)
      }

      if (cartDrawer && firstAtc) {
        if (window.cartNotificationTimeout) {
          clearTimeout(window.cartNotificationTimeout);
        }
        // Set timeout to let the section render before opening, otherwise the animation won't show
        setTimeout(()=> {
          cartDrawer.classList.add('active');
          dispatchCustomEvent('cart-drawer:open');
        }, 100);
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

function appendUpsellMobileLineItemProperties(formData, root) {
  const propertyInput = root.querySelector('input[name="properties[_upsellMobile]"]');

  if (propertyInput?.value) {
    console.log('propertyInput.value', propertyInput.value);
    formData.append('properties[_upsellMobile]', propertyInput.value);
  }
}

/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }
    setEventListeners() {
      this.button.addEventListener('click', this.addToCart.bind(this));
    }
    getSectionsToRender() {
      return [
      {
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Notification',
        section: 'cart-drawer',
        selector: '.cart-popup'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    addToCart() {
      this.button.classList.add('loading');
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      const formData = new FormData();

      appendUpsellMobileLineItemProperties(formData, this);

      formData.append('id', this.id);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }

          this.renderContents(response);

          const productTitle = response.hasOwnProperty('items') ? response.items[0].title : response.title;
          this.announceCartUpdate(productTitle);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        });
    }
    
    announceCartUpdate(productTitle) {
      let liveRegion = document.getElementById('cart-live-region-text');
      if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.id = 'cart-live-region-text';
        liveRegion.setAttribute('role', 'status');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.className = 'visually-hidden';
        document.body.appendChild(liveRegion);
      }
      
      const message = theme.strings?.addedToCart 
        ? theme.strings.addedToCart.replace('{{ product }}', productTitle)
        : `${productTitle} wurde zum Warenkorb hinzugefügt`;
      
      liveRegion.textContent = '';
      setTimeout(() => {
        liveRegion.textContent = message;
      }, 100);
    }
    
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      const cartDrawer = document.getElementById('Cart-Drawer');
      const cartDrawerActive = cartDrawer?.classList?.contains('active');
      const lineItems = cartDrawer?.querySelectorAll(".cart-item__grid quantity-selector");
      const firstAtc = lineItems?.length === 1 && lineItems[0].querySelector('input[value="1"]');

      const cartNotification = document.getElementById('Cart-Notification');
      if (cartNotification && !cartDrawerActive && !firstAtc) {
        if (window.cartNotificationTimeout) {
          clearTimeout(window.cartNotificationTimeout);
        }

        cartNotification.classList.add('active');
        dispatchCustomEvent('cart-drawer:open');

        // Remove active state after 6s
        window.cartNotificationTimeout = setTimeout(()=> {
          cartNotification.classList.remove('active');
        }, 6000)
      }

      if (cartDrawer && firstAtc) {
        // Set timeout to let the section render before opening, otherwise the animation won't show
        setTimeout(()=> {
          cartDrawer.classList.add('active');
          dispatchCustomEvent('cart-drawer:open');
        }, 100);
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card-small', ProductCardSmall);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    this.addEventListener('keydown', (e) => this.handleKeydown(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            if (document.body.classList.contains('open-cc--product')) {
              document.body.classList.remove('open-cc--product');

              setTimeout(() => {
                document.querySelector('#Product-Drawer-Content').innerHTML = '';
              }, 260);
            } else {
              if (panel.classList.contains('cart-drawer')) {
                document.getElementById('cart-drawer-toggle').focus();
              }
              document.body.classList.remove('open-cc');
            }
            panel.classList.remove('active');
            document.body.classList.remove('bodylock');
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      let panel = document.querySelector('.side-panel.active');
      if (panel) {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
        document.body.classList.remove('bodylock');
      }
    });
  }

  handleKeydown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.close_panel(e);
    }
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    document.body.classList.remove('bodylock');

    if (panel.classList.contains('cart-popup')) {
      panel.style.display = 'none'
    }

    setTimeout(()=> {
      panel.removeAttribute('style');
    }, 250)
    
    if (document.body.classList.contains('open-cc--product')) {
      document.body.classList.remove('open-cc--product');
      
      dispatchCustomEvent('quick-view:close');
      
      setTimeout(() => {
        document.querySelector('#Product-Drawer-Content').innerHTML = '';

        if (window.lastFocusedElement) {
          window.lastFocusedElement.focus();
          window.lastFocusedElement = null;
        }
      }, 260);
    } else {
      document.body.classList.remove('open-cc');
    }
  }
}
customElements.define('side-panel-close', PanelClose);

window.cartNotificationTimeout = null;

/**
 *  @class
 *  @function CartNotification
 */
class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.triggerElement = null;
    this.focusableSelector = 'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
    this.boundTrapFocus = this.trapFocus.bind(this);
    this.boundHandleEscape = this.handleEscape.bind(this);
    this.boundOnFocusIn = this.onFocusIn.bind(this);
    this.boundOnFocusOut = this.onFocusOut.bind(this);
    this.boundOnMouseEnter = this.onMouseEnter.bind(this);
    this.boundOnMouseLeave = this.onMouseLeave.bind(this);
  }
  
  connectedCallback() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          if (this.classList.contains('active')) {
            this.onOpen();
          } else {
            this.onClose();
          }
        }
      });
    });
    
    this.observer.observe(this, { attributes: true });
    
    this.addEventListener('focusin', this.boundOnFocusIn);
    this.addEventListener('focusout', this.boundOnFocusOut);
    this.addEventListener('mouseenter', this.boundOnMouseEnter);
    this.addEventListener('mouseleave', this.boundOnMouseLeave);
  }
  
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.removeEventListener('focusin', this.boundOnFocusIn);
    this.removeEventListener('focusout', this.boundOnFocusOut);
    this.removeEventListener('mouseenter', this.boundOnMouseEnter);
    this.removeEventListener('mouseleave', this.boundOnMouseLeave);
    document.removeEventListener('keydown', this.boundTrapFocus);
    document.removeEventListener('keydown', this.boundHandleEscape);
    this.clearAutoCloseTimeout();
  }
  
  onFocusIn() {
    this.clearAutoCloseTimeout();
  }
  
  onFocusOut(event) {
    if (!this.contains(event.relatedTarget)) {
      this.startAutoCloseTimeout();
    }
  }
  
  onMouseEnter() {
    this.clearAutoCloseTimeout();
  }
  
  onMouseLeave() {
    if (!this.contains(document.activeElement)) {
      this.startAutoCloseTimeout();
    }
  }
  
  clearAutoCloseTimeout() {
    if (window.cartNotificationTimeout) {
      clearTimeout(window.cartNotificationTimeout);
      window.cartNotificationTimeout = null;
    }
  }
  
  startAutoCloseTimeout() {
    this.clearAutoCloseTimeout();
    if (this.classList.contains('active')) {
      window.cartNotificationTimeout = setTimeout(() => {
        this.classList.remove('active');
      }, 6000);
    }
  }
  
  onOpen() {
    this.triggerElement = document.activeElement;
    
    document.addEventListener('keydown', this.boundTrapFocus);
    document.addEventListener('keydown', this.boundHandleEscape);
    
    requestAnimationFrame(() => {
      const firstCloseButton = this.querySelector('side-panel-close');
      if (firstCloseButton) {
        firstCloseButton.focus();
      }
    });
  }
  
  onClose() {
    document.removeEventListener('keydown', this.boundTrapFocus);
    document.removeEventListener('keydown', this.boundHandleEscape);
    
    this.clearAutoCloseTimeout();
    
    if (this.triggerElement && this.triggerElement.focus) {
      requestAnimationFrame(() => {
        this.triggerElement.focus();
        this.triggerElement = null;
      });
    }
  }
  
  trapFocus(event) {
    if (event.key !== 'Tab') return;
    
    const focusableElements = this.querySelectorAll(this.focusableSelector);
    const visibleFocusable = Array.from(focusableElements).filter(el => {
      return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden';
    });
    
    if (visibleFocusable.length === 0) return;
    
    const firstElement = visibleFocusable[0];
    const lastElement = visibleFocusable[visibleFocusable.length - 1];
    
    if (event.shiftKey) {
      if (document.activeElement === firstElement || !this.contains(document.activeElement)) {
        event.preventDefault();
        lastElement.focus();
      }
    } else {
      if (document.activeElement === lastElement || !this.contains(document.activeElement)) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  }
  
  handleEscape(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
  
  close() {
    this.classList.remove('active');
    document.body.classList.remove('open-cc');
    document.body.classList.remove('bodylock');
  }
}
customElements.define('cart-notification', CartNotification);

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.containerCartDrawer = document.getElementById('Cart-Drawer');
    this.containerCartNotification = document.getElementById('Cart-Notification');

    if (!this.containerCartDrawer || !this.containerCartNotification) {
      return;
    }
  
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.containerCartDrawer.addEventListener('change', this.debouncedOnChange.bind(this));
    this.containerCartNotification.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    // Terms checkbox
    this.termsCheckbox();
  }
  
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }

  removeProductEvent() {
    const drawerRemoves = this.containerCartDrawer.querySelectorAll('.remove');

    drawerRemoves.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });

    const notifRemoves = this.containerCartNotification.querySelectorAll('.remove');

    notifRemoves.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [
      {
        id: 'Cart-Notification',
        section: 'cart-drawer',
        selector: '.cart-popup'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
        },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }
    ];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.containerCartDrawer.querySelector('#CartDrawerTerms'),
      checkout_button = this.containerCartDrawer.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
   displayErrors(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      this.containerCartDrawer.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
      // this.containerCartDrawer.querySelector(`#CartItem-${line}`).classList.remove('loading');
    }
  }
  updateQuantity(line, quantity) {
    this.containerCartDrawer.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    this.containerCartNotification.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
          if (parsedState.errors) {
            this.displayErrors(line, parsedState.errors);
            return;
          }

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));
        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
        if (this.containerCartDrawer.querySelector(`#CartDrawerItem-${line}`)) {
          this.containerCartDrawer.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
        if (this.containerCartNotification.querySelector(`#CartDrawerItem-${line}`)) {
          this.containerCartNotification.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
  refresh() {
    let sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
      });
  }
}

/**
 *  @class
 *  @function DrawerProductRecommendations
 */
if (!customElements.get('drawer-product-recommendations')) {
  class DrawerProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    fetchProducts() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector(`drawer-product-recommendations[data-type=${this.dataset.type}]`);
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          this.classList.add('product-recommendations--loaded');
        })
        .catch(e => {
          console.error(e);
        });
    }
    connectedCallback() {
      this.fetchProducts();
    }
  }
  customElements.define('drawer-product-recommendations', DrawerProductRecommendations);
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.variantSelector = this.querySelector(".product-card-variants");
    this.focusableElements = null;
    this.firstFocusableElement = null;
    this.lastFocusableElement = null;
    this.boundHandleKeydown = this.handleKeydown.bind(this);
    this.boundHandleFocusin = this.handleFocusin.bind(this);

    this.querySelector('[id^="ModalClose-"]')?.addEventListener(
      'click',
      this.hide.bind(this)
    );
    
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }

    if (this.variantSelector) {
      this.variantSelector.addEventListener("click", (event) => {
        const radioButton = event.target.closest(".radio-button");
        if (!radioButton) return;
        const input = radioButton.querySelector("input");
        if (input && input.disabled) return;
        setTimeout(() => this.hide(event), 200);
      });
      
      this.variantSelector.addEventListener("keydown", (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          const input = event.target.closest('label')?.querySelector('input') || event.target;
          if (input && input.type === 'radio' && !input.disabled) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            setTimeout(() => this.hide(event), 200);
          }
        }
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  handleKeydown(event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      event.preventDefault();
      event.stopPropagation();
      this.hide();
      return;
    }
    
    if (event.code.toUpperCase() === 'TAB') {
      this.trapFocus(event);
    }
  }
  
  handleFocusin(event) {
    if (!this.contains(event.target)) {
      event.preventDefault();
      event.stopPropagation();
      this.updateFocusableElements();
      if (this.firstFocusableElement) {
        this.firstFocusableElement.focus();
      }
    }
  }

  trapFocus(event) {
    this.updateFocusableElements();
    
    if (!this.focusableElements || this.focusableElements.length === 0) return;
    
    const activeElement = document.activeElement;
    const currentIndex = Array.from(this.focusableElements).indexOf(activeElement);
    
    if (event.shiftKey) {
      event.preventDefault();
      if (currentIndex <= 0 || currentIndex === -1) {
        this.lastFocusableElement.focus();
      } else {
        this.focusableElements[currentIndex - 1].focus();
      }
    } else {
      event.preventDefault();
      if (currentIndex === -1 || currentIndex >= this.focusableElements.length - 1) {
        this.firstFocusableElement.focus();
      } else {
        this.focusableElements[currentIndex + 1].focus();
      }
    }
  }

  updateFocusableElements() {
    const dialogContent = this.querySelector('.product-card-variants-modal__content') || this;
    this.focusableElements = dialogContent.querySelectorAll(
      'button:not([disabled]):not([tabindex="-1"]), ' +
      '[href]:not([tabindex="-1"]), ' +
      'input:not([disabled]):not([tabindex="-1"]), ' +
      'select:not([disabled]):not([tabindex="-1"]), ' +
      'textarea:not([disabled]):not([tabindex="-1"]), ' +
      '[tabindex]:not([tabindex="-1"]):not([disabled])'
    );
    
    if (this.focusableElements.length > 0) {
      this.firstFocusableElement = this.focusableElements[0];
      this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];
    }
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    
    if (opener && opener.button) {
      opener.button.setAttribute('aria-expanded', 'true');
    }
    
    this.lockBackground();
    
    document.addEventListener('keydown', this.boundHandleKeydown, true);
    document.addEventListener('focusin', this.boundHandleFocusin, true);
    
    setTimeout(() => {
      this.updateFocusableElements();
      const firstRadio = this.querySelector('input[type="radio"]:not([disabled])');
      const closeButton = this.querySelector('[id^="ModalClose-"]');
      
      if (firstRadio) {
        firstRadio.focus();
      } else if (closeButton) {
        closeButton.focus();
      } else if (this.firstFocusableElement) {
        this.firstFocusableElement.focus();
      }
    }, 100);
  }

  lockBackground() {
    const bodyChildren = document.body.children;
    for (let i = 0; i < bodyChildren.length; i++) {
      const child = bodyChildren[i];
      if (child !== this && 
          child.tagName !== 'SCRIPT' && 
          child.tagName !== 'STYLE' && 
          child.tagName !== 'LINK' &&
          !child.hasAttribute('aria-live')) {
        child.setAttribute('inert', '');
        child.setAttribute('data-modal-inert', '');
      }
    }
  }
  
  unlockBackground() {
    const inertElements = document.querySelectorAll('[data-modal-inert]');
    inertElements.forEach(el => {
      el.removeAttribute('inert');
      el.removeAttribute('data-modal-inert');
    });
  }

  hide(event) {
    const checkedInput = this.querySelector('input[type="radio"]:checked');
    if (checkedInput && this.openedBy && typeof this.openedBy.updateVariant === 'function') {
      this.openedBy.updateVariant(this);
    }
    
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    
    document.removeEventListener('keydown', this.boundHandleKeydown, true);
    document.removeEventListener('focusin', this.boundHandleFocusin, true);
    
    if (this.openedBy && this.openedBy.button) {
      this.openedBy.button.setAttribute('aria-expanded', 'false');
    }
    
    this.unlockBackground();
    
    if (this.openedBy && this.openedBy.button) {
      this.openedBy.button.focus();
    }
    
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    if (!this.button) return;

    const modalSelector = this.getAttribute('data-modal');
    const productId = this.getAttribute('data-product-id');
    this.modal = document.querySelector(`${modalSelector}[data-product-id="${productId}"]`);
    this.addToCartButton = document.querySelector(`button.product-card--add-to-cart-button[data-product-id="${productId}"]`);

    if (productId) {
      this.button.addEventListener('click', () => {
        if (this.modal) this.modal.show(this);  
      });
      
      this.button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (this.modal) this.modal.show(this);
        }
      });

      const closeButton = this.modal?.querySelector('.product-card-variants-modal__toggle');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.updateVariant(this.modal);
        });
      }

      this.modal?.addEventListener('click', (event) => {
        if (event.target === this.modal) {
          this.modal.style.display = 'none';
          this.updateVariant(this.modal);
        }
      });
    } else {
      this.button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(this);
      });
    }
  }

  updateVariant(modal) {
    const selectedVariant = modal.querySelector('input[type="radio"]:checked');
    if (selectedVariant) {
      const selectedVariantTitle = selectedVariant.getAttribute('data-title');
      const selectedVariantID = selectedVariant.value || selectedVariant.getAttribute('id');
      const titleSpan = this.button.querySelector('#selected-variant-title');
      if (titleSpan) {
        titleSpan.textContent = selectedVariantTitle.split(",").pop().trim();
      }
      modal.setAttribute('data-product-id', selectedVariantID);
      if (this.addToCartButton) {
        this.addToCartButton.setAttribute('data-product-id', selectedVariantID);
        this.addToCartButton.dataset.selectedProductId = selectedVariantID;
      }
    }
  }
}

customElements.define('modal-opener', ModalOpener);
/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select');
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);

    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-widget-title.collapsible").forEach((button) => {
      button.addEventListener("click", (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      };
      this.autoClose = this.dataset.autoClose;
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this));
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.detailsements.panel.querySelectorAll('button').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('custom-select--active');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.detailsements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.detailsements.input.value = event.currentTarget.dataset.value;
      this.detailsements.input.dispatchEvent(new Event('change'));
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent;
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'));
      }
      if (this.autoClose) {
        this.classList.remove('custom-select--active');
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle('custom-select--active');
      if (this.classList.contains('custom-select--active')) {
        this.detailsements.button.focus();
        this.detailsements.button.setAttribute('aria-expanded', (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString());
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('custom-select', CustomSelect);
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('input[name="locale_code"], input[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));

      if (this.querySelector(".location_popup_wrapper")) {
        this.show_popup = localStorage.getItem('location_state');
        window.addEventListener('resize', () => {
          this.show_popup = localStorage.getItem('location_state');
        })
      
        if(this.show_popup == null || this.show_popup == false){
        this.querySelector(".location_popup_wrapper").style.display = "flex"
          this.buttons = this.querySelectorAll(".location_popup_button")
          this.buttons.forEach((button) => {
            button.addEventListener('click', () => {
              localStorage.setItem('location_state', "true")
              this.querySelector(".location_popup_wrapper").style.display = "none"
            })
          })
        }

      }
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');

      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class SubscriptionWidget extends HTMLElement{
  constructor(){
    super()
    this.oneTimeBtn = this.querySelector('.product-information .product-price-simple');
    this.subscriptionBtn = this.querySelector('.product-information .product-price-subscription-button');
    this.productId= this.dataset.productId
    
    requestAnimationFrame(() => {
      if (this.oneTimeBtn && this.oneTimeBtn.classList.contains('active')) {
        this.setSellingPlanInProductForms(null);
      }
    });
    
    if(this.oneTimeBtn){
      const handleOneTimeClick = () => {
        this.informationSelector = this.dataset.informationSelector || '.subscription-information'
        this.oneTimeBtn.classList.add("active");
        this.subscriptionBtn.classList.remove("active");
        
        this.oneTimeBtn.setAttribute('aria-checked', 'true');
        if (this.subscriptionBtn) {
          this.subscriptionBtn.setAttribute('aria-checked', 'false');
        }
        
        // Hide subscription info
        const informationElement = document.querySelector(this.informationSelector);
        if(informationElement) informationElement.style.display = 'none';
        this.setSellingPlanInProductForms(null)

        // Show package selection
        document.querySelector(".package-selection")?.classList.remove("hidden");
      };
      
      this.oneTimeBtn.addEventListener('click', handleOneTimeClick);
      this.oneTimeBtn.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleOneTimeClick();
        }
      });
    }
    if(this.subscriptionBtn)
    {
      const handleSubscriptionClick = (event) => {
        this.informationSelector = this.dataset.informationSelector || '.subscription-information'
        this.oneTimeBtn.classList.remove("active");
        this.subscriptionBtn.classList.add("active");
        
        this.subscriptionBtn.setAttribute('aria-checked', 'true');
        if (this.oneTimeBtn) {
          this.oneTimeBtn.setAttribute('aria-checked', 'false');
        }
        
        // Show subscription info
        const informationElement = document.querySelector(this.informationSelector);
        if(informationElement) informationElement.style.display = 'flex';
        const targetElement = event?.target?.closest("[data-selling-plan]") || this.subscriptionBtn.closest("[data-selling-plan]");
        const newSellingPlan = targetElement?.dataset.sellingPlan;
        this.setSellingPlanInProductForms(newSellingPlan)

        // Hide package selection
        const wrapper = this.closest('.thb-product-detail') || document;
        const variantSelects = wrapper.querySelectorAll('variant-selects');
        variantSelects.forEach(function (variant) {
          if(variant){
            variant.classList.remove('hidden'); // Remove each variant-selects inside
          }
        });
        document.querySelector("multi-button-select")?.classList.add("hidden");
        document.querySelector(".package-selection")?.classList.add("hidden");
      };
      
      this.subscriptionBtn.addEventListener('click', handleSubscriptionClick);
      this.subscriptionBtn.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          handleSubscriptionClick(event);
        }
      });
    }



  }
  
  setSellingPlanInProductForms(sellingPlan) {
    const productInputs = document.querySelectorAll('input[name="product-id"]');
    const matchingInputs = Array.from(productInputs).filter(input => input.value === this.productId);
    const planId = String(sellingPlan ?? '').trim();
    const hasPlanId = /^\d+$/.test(planId);
  
    matchingInputs.forEach(input => {
      let form = input.closest("form");
      if (!form) return;
      const sellingPlanInputs = form.querySelector("input[name='selling_plan']");
      
      if (!hasPlanId) {
        if (sellingPlanInputs) {
          sellingPlanInputs.remove();
        }
        return;
      }
      
      if (sellingPlanInputs != undefined) {
        sellingPlanInputs.disabled = false;
        sellingPlanInputs.value = planId;
      }
      else{
        // Create a new hidden input element for the selling plan
        const sellingPlanInput = document.createElement("input");
        sellingPlanInput.type = "hidden";
        sellingPlanInput.name = "selling_plan";
        sellingPlanInput.value = planId;
        form.appendChild(sellingPlanInput);
      }
    });
  }}
customElements.define("subscription-widget", SubscriptionWidget)




/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
      this.focusableElements = null;
      this.firstFocusableElement = null;
      this.lastFocusableElement = null;
      this.boundHandleDrawerKeydown = this.handleDrawerKeydown.bind(this);
      this.boundHandleFocusin = this.handleFocusin.bind(this);
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture--product');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));
      this.addEventListener('keydown', this.handleKeydown.bind(this));
      
      document.addEventListener('quick-view:close', this.removeTrapFocus.bind(this));
    }
    
    setupCCEventListener(e) {
      this.closeDrawer();
    }

    removeTrapFocus() {
      document.removeEventListener('keydown', this.boundHandleDrawerKeydown, true);
      document.removeEventListener('focusin', this.boundHandleFocusin, true);
      this.focusableElements = null;
      this.firstFocusableElement = null;
      this.lastFocusableElement = null;
    }

    closeDrawer() {
      this.body.classList.remove('open-cc--product');
      this.drawer.classList.remove('active');
      
      this.removeTrapFocus();

      setTimeout(() => {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
        
        if (window.lastFocusedElement) {
          window.lastFocusedElement.focus();
          window.lastFocusedElement = null;
        }
      }, 260);
    }

    handleDrawerKeydown(event) {
      if (event.code.toUpperCase() === 'ESCAPE') {
        event.preventDefault();
        event.stopPropagation();
        this.closeDrawer();
        return;
      }
      
      if (event.code.toUpperCase() === 'TAB') {
        this.trapFocus(event);
      }
    }

    handleFocusin(event) {
      if (!this.drawer.contains(event.target)) {
        event.preventDefault();
        event.stopPropagation();
        this.updateFocusableElements();
        if (this.firstFocusableElement) {
          this.firstFocusableElement.focus();
        }
      }
    }

    trapFocus(event) {
      if (!this.focusableElements || this.focusableElements.length === 0) {
        this.updateFocusableElements();
      }
      
      if (!this.focusableElements || this.focusableElements.length === 0) return;
      
      const activeElement = document.activeElement;
      let currentIndex = this.focusableElements.indexOf(activeElement);
      
      if (currentIndex === -1) {
        for (let i = 0; i < this.focusableElements.length; i++) {
          if (this.focusableElements[i].contains(activeElement)) {
            currentIndex = i;
            break;
          }
        }
      }
      
      if (event.shiftKey) {
        event.preventDefault();
        if (currentIndex <= 0 || currentIndex === -1) {
          this.lastFocusableElement.focus();
        } else {
          this.focusableElements[currentIndex - 1].focus();
        }
      } else {
        event.preventDefault();
        if (currentIndex === -1 || currentIndex >= this.focusableElements.length - 1) {
          this.firstFocusableElement.focus();
        } else {
          this.focusableElements[currentIndex + 1].focus();
        }
      }
    }

    updateFocusableElements() {
      const drawerContent = this.drawer.querySelector('.side-panel-inner') || this.drawer;
      const allFocusable = drawerContent.querySelectorAll('a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
      
      this.focusableElements = Array.from(allFocusable).filter(el => {
        const style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
      
      if (this.focusableElements.length > 0) {
        this.firstFocusableElement = this.focusableElements[0];
        this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];
      }
    }

    handleKeydown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.setupEventListener(e);
      }
    }

    setupEventListener(e) {
      e.preventDefault();
      window.lastFocusedElement = document.activeElement;
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');

        document.addEventListener('keydown', this.boundHandleDrawerKeydown, true);
        document.addEventListener('focusin', this.boundHandleFocusin, true);

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        setTimeout(() => {
          this.updateFocusableElements();
        }, 500);

        setTimeout(() => {
          let slider = this.drawer.querySelector('#Product-Slider');

          slider.reInit();
          window.dispatchEvent(new Event('resize'));
        }, 100);

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function StickyNote
 */
if (!customElements.get('sticky-note')) {
  class StickyNote extends HTMLElement {
    constructor() {
      super();
      this.smallSticky = this.querySelector(".sticky_small")
      this.stickyNote = this.querySelector(".sticky_note")

      // set left spacing of open button to 0
      document.addEventListener("DOMContentLoaded", () => {
        this.smallSticky?.setAttribute("style", `left: -${(this.smallSticky.offsetWidth / 2) - (this.smallSticky.offsetHeight / 2) + 5}px`)
      })
      
      // add Eventlisteners
      this.closeButton = this.querySelector(".sticky_close")
      this.removeButton = this.querySelector(".close_sticky_small")
      this.openButton = this.querySelector(".sticky_small_button")
      if(this.closeButton){
      this.closeButton.addEventListener("click", () => {
        this.close()
      })}
      if(this.removeButton)
      {this.removeButton.addEventListener("click", () => {
        this.remove()
      })}
      if(this.openButton){
      this.openButton.addEventListener("click", () => {
        this.open()
      })}
    }
    close() {
      this.stickyNote.classList.remove("open")
      this.smallSticky.classList.add("open")
    }
    remove() {
      this.stickyNote.classList.remove("open")
      this.smallSticky.classList.remove("open")
    }
    open() {
      this.stickyNote.classList.add("open")
      this.smallSticky.classList.remove("open")
    }

  }

  customElements.define('sticky-note', StickyNote);
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {

  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path');
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: "0%",
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%'
        }
      });
    });
  }

}

/**
 * @class
 * @function OpenPopup
 */
class OpenPopup extends HTMLElement{
	constructor(){
		super()
		this.popup = document.querySelector(`#${this.dataset.popup}`)
		this.addEventListener("click",this.open.bind(this))

	}
	open(event){
		document.querySelector("body").classList.add("lock-position")
		this.popup.closest("popup-controller")?.classList.remove("hidden")
		this.popup.classList.remove("hidden")
	}
}
if(!customElements.get("open-popup")){
	customElements.define("open-popup",OpenPopup)
}

/**
 * @class
 * @function closePopup
 */
class closePopup extends HTMLElement{
	constructor(){
		super()
		this.addEventListener("click", this.close.bind(this))
	}
	close(){
		this.closest(".popup")?.classList.add("hidden")
		this.closest(".popup-controller").classList.add("hidden")
		document.querySelector("body").classList.remove("lock-position")
	}
}
customElements.define("close-popup",closePopup)

/**
 * @class
 * @function popupController
 */
class popupController extends HTMLElement{
	constructor(){
		super()
		this.addEventListener("click", (event) => this.close(event))
	}
	close(event){
		if(event.target.closest(".popup")){
			return
		}
		else{
			this.classList.add("hidden")
			// this.querySelector(".product-popup-wrapper:not(.hidden)").classList.add("hidden")
			this.querySelector(".popup:not(.hidden)").classList.add("hidden")
			document.querySelector("body").classList.remove("lock-position")
		}
	}
}
customElements.define("popup-controller",popupController)


/**
 * 
 */
document.addEventListener('DOMContentLoaded', () => {

  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }

  onLoadDeleteSellingPlanCookie();
});

const onLoadDeleteSellingPlanCookie = async () => {
  const cart = await fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      return data
    })

  if (cart && cart.items.length === 0) deleteCookie("active_selling_plan")
}


function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

/**
 * Klavyio Newsletter 
 */
class klaviyoForm extends HTMLElement{
  constructor(){
    super()
    this.list_id = this.dataset.listId
    this.email_input = this.querySelector("input[type='email']")
    this.field_label = this.querySelector("form .field__label");
    this.submit_button = this.querySelector("[id^='submit--klaviyo']")
    this.submit_button.addEventListener("click",this.submit.bind(this))
    this.company_id = "SDeQmC"
  }

  async submit(event){
    event.preventDefault();

    if (!this.email_input.checkValidity()) {
      this.email_input.reportValidity();
      return;
    }

    let request = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: `${this.email_input.value}`
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: `${this.list_id}`
            }
          }
        }
      }
    };

    let requestOptions = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-07-15'
      },
      body: JSON.stringify(request)
    };

    try {  
      let response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.company_id}`, requestOptions);

      if(!response.ok){
        throw new Error(`Server error: ${response.status}`);
      }
  
      this.email_input.value = "Vielen Dank für deine Anmeldung!";
      this.querySelector(".button--error").style.display = "none";

      document.dispatchEvent(new CustomEvent('nl:submitted'));
    } catch(error){
      console.error("Fehler beim Absenden des Formulars:", error);
      this.querySelector(".button--error").style.display = "block";
    }
  }

}

customElements.define("klaviyo-form",klaviyoForm)

/**
 * Klavyio Back in Stock
 */
class klaviyoBackInStockForm extends klaviyoForm {
	constructor(){
		super()
		this.variant_id = this.dataset.variantId
    this.newsletter_checkbox = this.querySelector("[id^='klaviyo--newslettercheckbox']")
		this.open_button = document.querySelector("open-popup[data-popup='popup--buy_buttons']")
    this.company_id = "SDeQmC";
    this.newsletter_list_id = "RN7LPT";
	}
	async submit(event){
    event.preventDefault();
    if (!this.email_input.checkValidity()) {
      this.email_input.reportValidity();
      return;
    }

		let request = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": `${this.email_input.value}`,
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${this.variant_id}`
            }
          }
        }
      }
    }
    let requestOptions = {
			method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-07-15'
      },
			body: JSON.stringify(request),
		};
    try {
      // IF subscribe to newsletter is checked
      if(this.newsletter_checkbox.checked){
        let requestNewsletter = {
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: `${this.email_input.value}`
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: `${this.newsletter_list_id}`
                }
              }
            }
          }
        };
        let requestOptionsNewsletter = {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-07-15'
          },
          body: JSON.stringify(requestNewsletter)
        };
        let responseNewsletter = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.company_id}`, requestOptionsNewsletter);
        if(!responseNewsletter.ok){
          throw new Error(`Server error: ${responseNewsletter.status}`);
        }
      }

      let response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.company_id}`, requestOptions)
      if(!response.ok){
        throw new Error(`Server error: ${response.status}`);
      }
      
      this.classList.add("submitted")
      this.querySelector(".button--error").style.display = "none";
      this.querySelector(".button-submit--klaviyo").classList.add("active")
    } catch(error){
      console.error("Fehler beim Absenden des Formulars:", error);
      this.querySelector(".button--error").style.display = "block";
    }
	}
}
if(!customElements.get("klaviyo-back-in-stock")){
	customElements.define("klaviyo-back-in-stock", klaviyoBackInStockForm)
}

/**
 *  @class
 *  @function UpsellingMobileOverlay
 */
if (!customElements.get('upselling-mobile-overlay')) {
  class UpsellingMobileOverlay extends HTMLElement {
    constructor() {
      super();
      this.trigger = null;
      this.overlay = null;
      this.panel = null;
      this.backdrop = null;
      this.closeBtn = null;
      this.recommendations = null;
      this.triggerTimeout = null;
      this.previousFocus = null;
      this.boundHandleKeydown = this.handleKeydown.bind(this);
      this.boundHandleDrawerOpen = this.handleDrawerOpen.bind(this);
      this.drawerObserver = null;
    }

    connectedCallback() {
      this.trigger = this.querySelector('.upselling-mobile-overlay__trigger');
      this.overlay = this.querySelector('.upselling-mobile-overlay__overlay');
      this.panel = this.querySelector('.upselling-mobile-overlay__panel');
      this.backdrop = this.querySelector('.upselling-mobile-overlay__backdrop');
      this.closeBtn = this.querySelector('.upselling-mobile-overlay__close');
      this.recommendations = this.querySelector('drawer-product-recommendations');
      this.delay = parseInt(this.dataset.triggerDelay || '0', 10) * 1000;

      this.trigger?.addEventListener('click', () => this.open());
      this.backdrop?.addEventListener('click', () => this.close());
      this.closeBtn?.addEventListener('click', () => this.close());

      document.addEventListener('cart-drawer:open', this.boundHandleDrawerOpen);
      this.observeCartDrawer();

      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer?.classList.contains('active')) {
        this.scheduleTrigger();
      }

      if (window.__upsellingOverlayKeepOpen) {
        window.__upsellingOverlayKeepOpen = false;
        requestAnimationFrame(() => this.open({ restoreFocus: false }));
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cart-drawer:open', this.boundHandleDrawerOpen);
      this.drawerObserver?.disconnect();
      clearTimeout(this.triggerTimeout);
      document.removeEventListener('keydown', this.boundHandleKeydown);
    }

    observeCartDrawer() {
      const cartDrawer = document.getElementById('Cart-Drawer');
      if (!cartDrawer) return;

      this.drawerObserver = new MutationObserver(() => {
        if (cartDrawer.classList.contains('active')) {
          this.scheduleTrigger();
        } else {
          this.resetTrigger();
          this.close({ restoreFocus: false });
        }
      });

      this.drawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    handleDrawerOpen() {
      this.scheduleTrigger();
    }

    scheduleTrigger() {
      clearTimeout(this.triggerTimeout);
      this.trigger?.classList.remove('is-visible');

      this.triggerTimeout = setTimeout(() => {
        const cartDrawer = document.getElementById('Cart-Drawer');
        if (cartDrawer?.classList.contains('active')) {
          this.trigger?.classList.add('is-visible');
        }
      }, this.delay);
    }

    resetTrigger() {
      clearTimeout(this.triggerTimeout);
      this.trigger?.classList.remove('is-visible');
    }

    open(options = {}) {
      const { restoreFocus = true } = options;
      if (!this.overlay || !this.trigger) return;

      this.previousFocus = restoreFocus ? document.activeElement : this.previousFocus;
      this.overlay.hidden = false;
      this.overlay.setAttribute('aria-hidden', 'false');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
      document.addEventListener('keydown', this.boundHandleKeydown);

      requestAnimationFrame(() => {
        this.panel?.focus();
      });
    }

    close(options = {}) {
      const { restoreFocus = true } = options;
      if (!this.overlay || !this.trigger) return;

      this.overlay.hidden = true;
      this.overlay.setAttribute('aria-hidden', 'true');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');
      document.removeEventListener('keydown', this.boundHandleKeydown);

      if (restoreFocus && this.previousFocus && typeof this.previousFocus.focus === 'function') {
        this.previousFocus.focus();
      }
    }

    handleKeydown(event) {
      if (event.code?.toUpperCase() === 'ESCAPE') {
        event.preventDefault();
        event.stopPropagation();
        this.close();
        return;
      }

      if (event.code?.toUpperCase() === 'TAB' && this.panel) {
        this.trapFocus(event);
      }
    }

    trapFocus(event) {
      const focusable = this.panel.querySelectorAll(
        'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      const focusableElements = Array.from(focusable).filter(el => el.offsetParent !== null);
      if (!focusableElements.length) return;

      const first = focusableElements[0];
      const last = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    reloadRecommendations() {
      if (this.recommendations && typeof this.recommendations.fetchProducts === 'function') {
        this.recommendations.classList.remove('product-recommendations--loaded');
        this.recommendations.fetchProducts();
      }
    }
  }

  customElements.define('upselling-mobile-overlay', UpsellingMobileOverlay);
}

/**
 *  @class
 *  @function ProductCardUpsellingOverlay
 */
if (!customElements.get('product-card-upselling-overlay')) {
  class ProductCardUpsellingOverlay extends HTMLElement {
    constructor() {
      super();
      this.variantSelect = null;
      this.atcButton = null;
      this.quantityInput = null;
      this.priceEl = null;
      this.unitPriceEl = null;
    }

    connectedCallback() {
      this.variantSelect = this.querySelector('[data-upselling-variant-select]');
      this.atcButton = this.querySelector('[data-upselling-atc]');
      this.quantityInput = this.querySelector('.qty');
      this.priceEl = this.querySelector('[data-upselling-price]');
      this.unitPriceEl = this.querySelector('[data-upselling-unit-price]');

      this.variantSelect?.addEventListener('change', this.onVariantChange.bind(this));
      this.atcButton?.addEventListener('click', this.addToCart.bind(this));
    }

    onVariantChange() {
      if (!this.variantSelect) return;

      const selectedOption = this.variantSelect.selectedOptions[0];
      if (!selectedOption) return;

      if (this.priceEl) {
        this.priceEl.textContent = selectedOption.dataset.priceDisplay || '';
      }
      if (this.unitPriceEl) {
        this.unitPriceEl.textContent = selectedOption.dataset.unitPriceDisplay || '';
      }

      const isAvailable = !selectedOption.disabled;
      this.atcButton.dataset.variantId = selectedOption.value;
      this.atcButton.disabled = !isAvailable;
      this.atcButton.toggleAttribute('aria-disabled', !isAvailable);
    }

    getSectionsToRender() {
      return [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        { id: 'Cart-Notification', section: 'cart-drawer', selector: '.cart-popup' },
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
      ];
    }

    addToCart(event) {
      event.preventDefault();
      if (this.atcButton.disabled || this.atcButton.classList.contains('loading')) return;

      const variantId = this.atcButton.dataset.variantId;
      const quantity = this.quantityInput?.value || 1;

      this.atcButton.classList.add('loading');
      this.atcButton.setAttribute('aria-disabled', 'true');

      window.__upsellingOverlayKeepOpen = true;

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      const formData = new FormData();

      appendUpsellMobileLineItemProperties(formData, this);

      formData.append('id', variantId);
      formData.append('quantity', quantity);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) return;
          this.renderContents(response);

          const productTitle = response.hasOwnProperty('items') ? response.items[0].title : response.title;
          this.announceCartUpdate(productTitle);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((error) => {
          console.error(error);
          window.__upsellingOverlayKeepOpen = false;
        })
        .finally(() => {
          this.atcButton.classList.remove('loading');
          this.atcButton.removeAttribute('aria-disabled');
        });
    }

    announceCartUpdate(productTitle) {
      let liveRegion = document.getElementById('cart-live-region-text');
      if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.id = 'cart-live-region-text';
        liveRegion.setAttribute('role', 'status');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.className = 'visually-hidden';
        document.body.appendChild(liveRegion);
      }

      const message = theme.strings?.addedToCart
        ? theme.strings.addedToCart.replace('{{ product }}', productTitle)
        : `${productTitle} wurde zum Warenkorb hinzugefügt`;

      liveRegion.textContent = '';
      setTimeout(() => {
        liveRegion.textContent = message;
      }, 100);
    }

    renderContents(parsedState) {
      const cartDrawer = document.getElementById('Cart-Drawer');
      const wasDrawerActive = cartDrawer?.classList.contains('active');

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = document.getElementById(section.id);
        if (!sectionElement) return;

        const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      });

      const updatedCartDrawer = document.getElementById('Cart-Drawer');
      if (updatedCartDrawer && (wasDrawerActive || window.__upsellingOverlayKeepOpen)) {
        updatedCartDrawer.classList.add('active');
        document.body.classList.add('open-cc');
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }

  customElements.define('product-card-upselling-overlay', ProductCardUpsellingOverlay);
}